import { defineStore } from "pinia";
// 用户相关
const useStore = defineStore("user", {
    state() {
        return {
            user: {},
            teams: [],
            teamname: ""
        };
    },
    actions: {
        logout() {
            const url = window.location.href;
            return (window.location.href =
                "https://actxyx.web.sdo.com/api/sdo/Logout.aspx?url=" + url);
        }
    }
});

export default useStore;
